import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../utils/Utils";
import Input from "../../../../../components/textbox/Input";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import Calendar from "../../../../../components/calendar/Calendar";
import OggettiUtili from "../../../../../utils/OggettiUtili"
import Select from "../../../../../components/select/Select"


const assistenzaMap = OggettiUtili.assistenza;

class InfoGravidanza extends Component {

    state = {
        infoGravidanza:
            {
                precGravidanze: "",
                parti: "",
                natiVivi: "",
                numAborti: "",
                nonNotoAborti: 0,
                numNatiMorti: "",
                nonNotoMorti: 0,
                dataUltima: "",
                dataPrima: "",
                assistenza: "",
                numBambiniConviventi: "",
                nonNotoBambini: 0,
                numVaccinati: "",
                nonNotoVaccinati: 0,
                corretto: []
            }

    }


    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.nonNotoAborti = this.nonNotoAborti.bind(this);
        this.nonNotoBambini = this.nonNotoBambini.bind(this);
        this.nonNotoNatiMorti = this.nonNotoNatiMorti.bind(this);
        this.nonNotoVaccinati = this.nonNotoVaccinati.bind(this);
        this.handleChangeAssistenza = this.handleChangeAssistenza.bind(this);
        this.validate = this.validate.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.setInfoGravidanzaInModifica = this.setInfoGravidanzaInModifica.bind(this)

    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.infoGravidanza) {
            this.setInfoGravidanzaInModifica()
            this.controlloCorrettezza()
            this.props.setInfoGravidanza(this.state.infoGravidanza, this)
        } else {
            this.controlloCorrettezza()
            this.props.setInfoGravidanza(this.state.infoGravidanza, this)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            this.props.setInfoGravidanza(this.state.infoGravidanza, this)
        }
    }

    setInfoGravidanzaInModifica() {
        let infoGravidanza = this.state.infoGravidanza;
        let propsGravidanza = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.infoGravidanza))
        infoGravidanza.assistenza = propsGravidanza.assistenza ? propsGravidanza.assistenza : ""
        infoGravidanza.dataPrima = propsGravidanza.dataPrima ? propsGravidanza.dataPrima : ""
        infoGravidanza.dataUltima = propsGravidanza.dataUltima ? propsGravidanza.dataUltima : ""
        infoGravidanza.natiVivi = propsGravidanza.natiVivi || propsGravidanza.natiVivi === 0 ? propsGravidanza.natiVivi : ""
        infoGravidanza.nonNotoAborti = propsGravidanza.nonNotoAborti ? propsGravidanza.nonNotoAborti : ""
        infoGravidanza.nonNotoMorti = propsGravidanza.nonNotoMorti ? propsGravidanza.nonNotoMorti : ""
        infoGravidanza.nonNotoBambini = propsGravidanza.nonNotoBambini ? propsGravidanza.nonNotoBambini : ""
        infoGravidanza.nonNotoVaccinati = propsGravidanza.nonNotoVaccinati ? propsGravidanza.nonNotoVaccinati : ""
        infoGravidanza.numNatiMorti = propsGravidanza.numNatiMorti || propsGravidanza.numNatiMorti === 0 ? propsGravidanza.numNatiMorti : ""
        infoGravidanza.numBambiniConviventi = propsGravidanza.numBambiniConviventi || propsGravidanza.numBambiniConviventi === 0 ? propsGravidanza.numBambiniConviventi : ""
        infoGravidanza.precGravidanze = propsGravidanza.precGravidanze || propsGravidanza.precGravidanze === 0 ? propsGravidanza.precGravidanze : ""
        infoGravidanza.parti = propsGravidanza.parti || propsGravidanza.parti === 0 ? propsGravidanza.parti : ""
        infoGravidanza.numAborti = propsGravidanza.numAborti || propsGravidanza.numAborti === 0 ? propsGravidanza.numAborti : ""
        infoGravidanza.numVaccinati = propsGravidanza.numVaccinati || propsGravidanza.numVaccinati === 0 ? propsGravidanza.numVaccinati : ""
        this.setState({infoGravidanza: infoGravidanza})
    }

    validate() {
        let validateDataUltima = Utils.checkDateInterval(this.state.infoGravidanza.dataUltima, "31/12/1899");
        let checkTodayDataUltima = Utils.checkDateLowerToday(this.state.infoGravidanza.dataUltima);
        let validatePrimaVisita = Utils.checkDateInterval(this.state.infoGravidanza.dataPrima, "31/12/1899");
        let checkTodayPrimaVisita = Utils.checkDateLowerToday(this.state.infoGravidanza.dataPrima);

        if (validateDataUltima) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_AG"]), 1
            )
        } else if (checkTodayDataUltima) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AH"]), 1
            )
        }

        if (validatePrimaVisita) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AI"]), 1
            )
        } else if (checkTodayPrimaVisita) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AL"]), 1
            )
        }

        if (this.state.infoGravidanza.precGravidanze && (parseInt(this.state.infoGravidanza.precGravidanze) < 0 || parseInt(this.state.infoGravidanza.precGravidanze) > 15)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DL"]), 1
            )
        }
        if (this.state.infoGravidanza.parti && (parseInt(this.state.infoGravidanza.parti) < 0 || parseInt(this.state.infoGravidanza.parti) > 15)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DM"]), 1
            )
        }
        if (this.state.infoGravidanza.natiVivi && (parseInt(this.state.infoGravidanza.natiVivi) < 0 || parseInt(this.state.infoGravidanza.natiVivi) > 15)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DN"]), 1
            )
        }
        if (this.state.infoGravidanza.numAborti && (parseInt(this.state.infoGravidanza.numAborti) < 0 || parseInt(this.state.infoGravidanza.numAborti) > 98)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DO"]), 1
            )
        }
        if (this.state.infoGravidanza.numNatiMorti && (parseInt(this.state.infoGravidanza.numNatiMorti) < 0 || parseInt(this.state.infoGravidanza.numNatiMorti) > 98)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DP"]), 1
            )
        }
        if (this.state.infoGravidanza.numBambiniConviventi && (parseInt(this.state.infoGravidanza.numBambiniConviventi) < 0 || parseInt(this.state.infoGravidanza.numBambiniConviventi) > 98)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DQ"]), 1
            )
        }
        if (this.state.infoGravidanza.numVaccinati && (parseInt(this.state.infoGravidanza.numVaccinati) < 0 || parseInt(this.state.infoGravidanza.numVaccinati) > 98)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DR"]), 1
            )
        }

        if ((this.state.infoGravidanza.numBambiniConviventi && this.state.infoGravidanza.numVaccinati &&
            (this.state.infoGravidanza.numBambiniConviventi < this.state.infoGravidanza.numVaccinati)) ||
            (!this.state.infoGravidanza.numBambiniConviventi && this.state.infoGravidanza.numVaccinati)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CZ"]), 1
            )
        }

        let infoGravidanza = Object.assign({}, this.state.infoGravidanza)
        let infoGravidanzaObj = Utils.removeFieldFromObject(infoGravidanza, "corretto");

        this.props.setInfoGravidanza(undefined, undefined, infoGravidanzaObj)
    }

    controlloCorrettezza() {

        let infoGravidanza = this.state.infoGravidanza
        infoGravidanza.corretto = []

        const {t} = this.props;

        if(!infoGravidanza.precGravidanze && infoGravidanza.precGravidanze !== 0){
            infoGravidanza.corretto[0] = "Campo \"N. precedenti gravidanze\" mancante"
        } else if(parseInt(infoGravidanza.precGravidanze) > 15 || parseInt(infoGravidanza.precGravidanze) < 0){
            infoGravidanza.corretto[0] = t("Messages.ERR_01_01_0F_CI")
        } else infoGravidanza.corretto[0] = ""


        if(!infoGravidanza.parti && infoGravidanza.parti !== 0){
            infoGravidanza.corretto[1] = "Campo \"Numero parti\" mancante"
        }
        else if(parseInt(infoGravidanza.parti) > 15 || parseInt(infoGravidanza.parti) < 0){
            infoGravidanza.corretto[1] = t("Messages.ERR_01_01_0F_CL")
        } else infoGravidanza.corretto[1] = ""


        if(!infoGravidanza.natiVivi && infoGravidanza.natiVivi !== 0 ){
            infoGravidanza.corretto[2] = "Campo \"Numero nati vivi\" mancante"
        } else if(parseInt(infoGravidanza.natiVivi) < 0 || parseInt(infoGravidanza.natiVivi) > 15){
            infoGravidanza.corretto[2] = t("Messages.ERR_01_01_0F_CM")
        } else infoGravidanza.corretto[2] = ""


        if((!infoGravidanza.numAborti && infoGravidanza.numAborti !== 0) && infoGravidanza.nonNotoAborti === 0 ){
            infoGravidanza.corretto[3] = "Campo \"Numero aborti\" mancante"
        } else if(parseInt(infoGravidanza.numAborti) < 0 || parseInt(infoGravidanza.numAborti) > 98){
            infoGravidanza.corretto[3] = t("Messages.ERR_01_01_0F_CN")
        }else infoGravidanza.corretto[3] = ""


        if(!infoGravidanza.numNatiMorti && infoGravidanza.numNatiMorti !== 0 && infoGravidanza.nonNotoMorti === 0 ){
            infoGravidanza.corretto[4] = "Campo \"Numero nati morti\" mancante o errato"
        } else if(parseInt(infoGravidanza.numNatiMorti) < 0 || parseInt(infoGravidanza.numNatiMorti) > 98){
            infoGravidanza.corretto[4] = t("Messages.ERR_01_01_0F_CO")
        }else infoGravidanza.corretto[4] = ""

        if((infoGravidanza.numBambiniConviventi || infoGravidanza.numBambiniConviventi === 0) && (parseInt(infoGravidanza.numBambiniConviventi) < 0 || parseInt(infoGravidanza.numBambiniConviventi) > 98)){
            infoGravidanza.corretto[5] = t("Messages.ERR_01_01_0F_CP")
        } else infoGravidanza.corretto[5] = ""

        if((infoGravidanza.numVaccinati || infoGravidanza.numVaccinati === 0) && (parseInt(infoGravidanza.numVaccinati) < 0 || parseInt(infoGravidanza.numVaccinati) > 98)){
            infoGravidanza.corretto[6] = t("Messages.ERR_01_01_0F_CQ")
        }else infoGravidanza.corretto[6] = ""

        if(infoGravidanza.dataPrima && Utils.isDateInValid(Utils.transformDateForBackend(infoGravidanza.dataPrima), "-")){
            infoGravidanza.corretto[7] = "Campo \"Data prima visita\" errato"
        } else if(infoGravidanza.assistenza !== "1" && infoGravidanza.dataPrima){
            infoGravidanza.corretto[7] = t("Messages.ERR_01_01_0F_CV")
        }
        else infoGravidanza.corretto[7] = ""

        if(infoGravidanza.dataUltima && Utils.isDateInValid(Utils.transformDateForBackend(infoGravidanza.dataUltima), "-")){
            infoGravidanza.corretto[8] = "Campo \"Data ultima mestruazione\" errato"
        } else infoGravidanza.corretto[8] = ""

        if(infoGravidanza.numVaccinati && infoGravidanza.numBambiniConviventi && infoGravidanza.numVaccinati > infoGravidanza.numBambiniConviventi){
            infoGravidanza.corretto[9] = t("Messages.ERR_01_01_0F_CZ")
        }
        else infoGravidanza.corretto[9] = ""

        this.setState({infoGravidanza: infoGravidanza})
    }


    riceviValore(field, event) {

        let data = this.state.infoGravidanza

        if (field === "precGravidanza") {
            data.precGravidanze = event.target.value;
        } else if (field === "parti") {
            data.parti = event.target.value;
        } else if (field === "natiVivi") {
            data.natiVivi = event.target.value;
        } else if (field === "aborti") {
            data.numAborti = event.target.value;
            data.nonNotoAborti = 0
        } else if (field === "natiMorti") {
            data.numNatiMorti = event.target.value;
            data.nonNotoMorti = 0
        } else if (field === "idBambiniConviventi") {
            data.numBambiniConviventi = event.target.value;
            data.nonNotoBambini = 0
        } else if (field === "idVaccinati") {
            data.numVaccinati = event.target.value;
            data.nonNotoVaccinati = 0
        } else if (field.currentTarget.id === "dataUltima") {
            data.dataUltima = field.target.value;
        } else if (field.currentTarget.id === "dataPrima") {
            data.dataPrima = field.target.value;
        }

        this.setState({infoGravidanza: data});
        this.controlloCorrettezza();
    }

    nonNotoAborti() {

        let newSections = this.state.infoGravidanza
        if (newSections.nonNotoAborti === 0) {
            newSections.nonNotoAborti = 1
            newSections.numAborti = ""
        } else {
            newSections.nonNotoAborti = 0
        }

        this.setState({infoGravidanza: newSections});
        this.controlloCorrettezza();
    }

    nonNotoNatiMorti() {

        let newSections = this.state.infoGravidanza
        if (newSections.nonNotoMorti === 0) {
            newSections.nonNotoMorti = 1
            newSections.numNatiMorti = ""
        } else {
            newSections.nonNotoMorti = 0
        }

        this.setState({infoGravidanza: newSections});
        this.controlloCorrettezza();
    }

    nonNotoBambini() {

        let newSections = this.state.infoGravidanza
        if (newSections.nonNotoBambini === 0) {
            newSections.nonNotoBambini = 1
            newSections.numBambiniConviventi = ""
        } else {
            newSections.nonNotoBambini = 0
        }


        this.setState({infoGravidanza: newSections});
        this.controlloCorrettezza();

    }

    nonNotoVaccinati() {

        let newSections = this.state.infoGravidanza
        if (newSections.nonNotoVaccinati === 0) {
            newSections.nonNotoVaccinati = 1
            newSections.numVaccinati = ""
        } else {
            newSections.nonNotoVaccinati = 0
        }
        this.setState({infoGravidanza: newSections});
        this.controlloCorrettezza();
    }

    handleChangeAssistenza(event) {

        let assistenza = this.state.infoGravidanza
        assistenza.assistenza = event.target.value

        this.setState({infoGravidanza: assistenza});
        this.controlloCorrettezza();

    }

    render() {

        const {t} = this.props;

        const firstsection = (

            <div>
                <div>
                    <p className={styles.titleText}>{t("DatiSpecifici.InfoGravidanza.titolo")}</p>
                    <hr className={styles.hr}/>
                </div>

                <div className={"container"}>

                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.precGravidanza")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Input type={"number"}
                                    min="0"
                                    id={"idprecGravidanza"}
                                    onChange={this.riceviValore}
                                    field={"precGravidanza"}
                                    value={this.state.infoGravidanza.precGravidanze}
                                    placeholder={t("DatiSpecifici.InfoGravidanza.precGravidanza")}
                                />
                            </div>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.parti")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Input type={"number"}
                                    min="0"
                                    id={"idparti"}
                                    onChange={this.riceviValore}
                                    field={"parti"}
                                    value={this.state.infoGravidanza.parti}
                                    placeholder={t("DatiSpecifici.InfoGravidanza.parti")}
                                />
                            </div>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.natiVivi")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Input type={"number"}
                                    min="0"
                                    id={"idnatiVivi"}
                                    onChange={this.riceviValore}
                                    field={"natiVivi"}
                                    value={this.state.infoGravidanza.natiVivi}
                                    placeholder={t("DatiSpecifici.InfoGravidanza.natiVivi")}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        );

        const secondSection = (

            <div className={"container"}>

                <div className="row" style={{marginTop: "1rem"}}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.aborti")} <span
                                className={styles.mandatoryColor}>*</span></p>
                            <Input id={"idaborti"}
                                type={"number"}
                                min="0"
                                onChange={this.riceviValore}
                                field={"aborti"}
                                value={this.state.infoGravidanza.numAborti}
                                placeholder={t("DatiSpecifici.InfoGravidanza.aborti")}
                            />
                        </div>
                    </div>

                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}
                         style={{marginTop: "2rem"}}>
                        <div className={styles.fieldContainer}>
                            <RadioButton id={"numAborti"}
                                name={"gruppo1"}
                                label={t("DatiSpecifici.InfoGravidanza.noto")}
                                value={this.state.infoGravidanza.nonNotoAborti}
                                onClick={this.nonNotoAborti}
                                checked={(this.state.infoGravidanza.nonNotoAborti === 1)}
                            />
                        </div>
                    </div>

                    {/*<div className="col-1" style={{marginLeft: "2px"}}></div>*/}
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.natiMorti")} <span
                                className={styles.mandatoryColor}>*</span></p>
                            <Input id={"idnatiMorti"}
                                type={"number"}
                                min="0"
                                onChange={this.riceviValore}
                                field={"natiMorti"}
                                value={this.state.infoGravidanza.numNatiMorti}
                                placeholder={t("DatiSpecifici.InfoGravidanza.natiMorti")}
                            />
                        </div>
                    </div>

                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                         style={{marginTop: "2rem"}}>
                        <div className={styles.fieldContainer}>
                            <RadioButton id={"numNatiMorti"}
                                name={"numNatiMorti"}
                                label={t("DatiSpecifici.InfoGravidanza.noto")}
                                value={this.state.infoGravidanza.nonNotoMorti}
                                onClick={this.nonNotoNatiMorti}
                                checked={this.state.infoGravidanza.nonNotoMorti === 1}
                            />

                        </div>
                    </div>

                </div>
            </div>
        );

        const thirdSection = (

            <div className={"container"}>
                <div className="row">
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.dataUltima")} </p>
                            <Calendar id={"dataUltima"} onChange={this.riceviValore} field={"dataUltima"}
                                      value={this.state.infoGravidanza.dataUltima} errorMessage={"Data non valida"}
                                      placeholder={t("DatiSpecifici.InfoGravidanza.dataUltima")}
                                      error={(this.state.infoGravidanza.dataUltima === "" || this.state.infoGravidanza.dataUltima == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoGravidanza.dataUltima), "-")
                                      }>
                            </Calendar>
                        </div>
                    </div>

                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.assistenza")} </p>
                        <Select
                            value={this.state.infoGravidanza.assistenza}
                            onChange={this.handleChangeAssistenza}
                            style={{width: "100%"}}
                            functionMap={assistenzaMap.map((oggetto) => {
                                return (<option value={oggetto.code}>{oggetto.displayName}</option>)
                            })}
                        >
                        </Select>

                    </div>


                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("DatiSpecifici.InfoGravidanza.dataPrima")} </p>
                            <Calendar id={"dataPrima"} onChange={this.riceviValore} field={"dataPrima"}
                                      value={this.state.infoGravidanza.dataPrima} errorMessage={"Data non valida"}
                                      placeholder={t("DatiSpecifici.InfoGravidanza.dataPrima")}
                                      error={(this.state.infoGravidanza.dataPrima === "" || this.state.infoGravidanza.dataPrima == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoGravidanza.dataPrima), "-")
                                      }
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          t("DatiSpecifici.InfoGravidanza.dataPrima"))}>
                            </Calendar>
                        </div>
                    </div>


                </div>
            </div>

        );

        const fourSection = (

            <div className={"container"} style={{marginTop: "1rem"}}>
                <div className="row">
                    <div className={"col-lg-8"}>
                        <p className={styles.testoGravidanza}>{t("DatiSpecifici.InfoGravidanza.testo1")}</p>
                    </div>
                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <Input
                                type={"number"}
                                min="0"
                                id={"idBambiniConviventi"}
                                onChange={this.riceviValore}
                                field={"idBambiniConviventi"}
                                value={this.state.infoGravidanza.numBambiniConviventi}
                                placeholder="Numero">
                            </Input>
                        </div>
                    </div>
                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <RadioButton id={"idNonNotoBambini"}
                            name={"idNonNotoBambini"}
                            label={t("DatiSpecifici.InfoGravidanza.noto")}
                            value={this.state.infoGravidanza.nonNotoBambini}
                            onClick={this.nonNotoBambini}
                            checked={this.state.infoGravidanza.nonNotoBambini === 1}
                        />
                    </div>
                </div>
            </div>

        );

        const fiveSection = (
            <div className={"container"}>
                <div className="row">
                    <div className={"col-lg-2"}>
                        <p className={styles.testoGravidanza}>{t("DatiSpecifici.InfoGravidanza.testo2")}</p>
                    </div>
                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <Input
                                type={"number"}
                                min="0"
                                id={"idVaccinati"}
                                onChange={this.riceviValore}
                                field={"idVaccinati"}
                                value={this.state.infoGravidanza.numVaccinati}
                                placeholder={"Numero"}>
                            </Input>
                        </div>
                    </div>
                    <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <RadioButton id={"nonNotoVaccinati"}
                            name={"nonNotoVaccinati"}
                            label={t("DatiSpecifici.InfoGravidanza.noto")}
                            value={this.state.infoGravidanza.nonNotoVaccinati}
                            onClick={this.nonNotoVaccinati}
                            checked={this.state.infoGravidanza.nonNotoVaccinati === 1}
                        />

                    </div>
                </div>
            </div>
        );

        const form = (

            <div>
                {firstsection}
                {secondSection}
                {thirdSection}
                {fourSection}
                {fiveSection}
            </div>
        );


        return (
            <div>
                <div style={{marginTop: "1rem"}}>
                    {form}
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(InfoGravidanza);
